module.exports = "/virtual-football-league/img/amblems/left/logos/EIBAR.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/EIBAR.png
// module id = 2066
// module chunks = 4